import { render, staticRenderFns } from "./CloudServicesAgreement.vue?vue&type=template&id=a7a9aaea&scoped=true"
var script = {}
import style0 from "./CloudServicesAgreement.vue?vue&type=style&index=0&id=a7a9aaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a9aaea",
  null
  
)

export default component.exports